// extracted by mini-css-extract-plugin
export var content = "_py-1";
export var fullScreen = "_py-0";